// Fonction pour formater les prix en FCFA (espace normal pour compatibilité PDF / jsPDF)
export const formatPrice = (price) => {
    if (price === undefined || price === null || price === '') return '0 XOF';
    const numericPrice = parseFloat(price);
    if (isNaN(numericPrice)) return '0 XOF';
    const formatted = numericPrice.toLocaleString('fr-FR', { useGrouping: true }).replace(/\u00A0/g, ' ');
    return `${formatted} XOF`;
};

// Fonction pour formater les nombres
export const formatNumber = (number) => {
    if (!number) return '0';
    
    const numericNumber = parseFloat(number);
    if (isNaN(numericNumber)) return '0';
    
    return numericNumber.toLocaleString('fr-FR');
}; 